exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.circle[data-v-4a8aa18f] {\n  border: 1px solid lightgrey;\n}\n.default-avatar[data-v-4a8aa18f] {\n  padding-left: 15%;\n  padding-right: 15%;\n  padding-bottom: 15%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4a8aa18f","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/account/AvatarForm.vue
// module id = WYFa
// module chunks = 1